import moment from 'moment';
import { Model } from '../Model.js';

var _dec, _class;

/**
 * Plain object Parcel representation.
 *
 */

/**
 * Serialized object Parcel representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Plain object Packlink's API POST payload representation.
 *
 */

/**
 * Plain object Packlink's API PUT payload representation.
 *
 */

let Parcel = (_dec = Model(), _dec(_class = class Parcel {
  /**
   * Takes a IParcelApiResponse from Packlink's API and returns a Parcel.
   *
   * @param response  IParcelApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new Parcel(response.height, response.length, response.weight, response.width, response.id, response.name, response.default, response.created_at ? moment(response.created_at, 'YYYY/MM/DD HH:mm:ss') : undefined, response.updated_at ? moment(response.updated_at, 'YYYY/MM/DD HH:mm:ss') : undefined);
  }

  /**
   * Takes a serialized Parcel and returns a Parcel.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Parcel.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedParcel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Parcel.
   *
   */

  /**
   * Takes a serialized Parcel and returns a Parcel.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Parcel.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedParcel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Parcel.
   *
   */

  /**
   * Takes a serialized Parcel and returns a Parcel.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Parcel.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedParcel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Parcel.
   *
   */

  /**
   * Takes a serialized Parcel and returns a Parcel.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Parcel.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedParcel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Parcel.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new Parcel(data.height, data.length, data.weight, data.width, data.id, data.name, data.isDefault, data.createdAt ? moment(data.createdAt, 'YYYY/MM/DD HH:mm:ss') : undefined, data.updatedAt ? moment(data.updatedAt, 'YYYY/MM/DD HH:mm:ss') : undefined);
  }

  /**
   * Returns a new Parcel. Typings of the properties depend on the class type param T
   *
   */
  constructor(height, length, weight, width, id, name, isDefault, createdAt, updatedAt) {
    this.height = height;
    this.length = length;
    this.weight = weight;
    this.width = width;
    this.id = id;
    this.name = name;
    this.isDefault = isDefault;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  /**
   * Returns a JSON serialized version of the Parcel.
   *
   */
  toJSON() {
    var _this$createdAt, _this$updatedAt;
    return {
      createdAt: (_this$createdAt = this.createdAt) === null || _this$createdAt === void 0 ? void 0 : _this$createdAt.format('YYYY-MM-DD HH:mm:ss'),
      height: this.height,
      id: this.id,
      isDefault: this.isDefault,
      length: this.length,
      name: this.name,
      updatedAt: (_this$updatedAt = this.updatedAt) === null || _this$updatedAt === void 0 ? void 0 : _this$updatedAt.format('YYYY-MM-DD HH:mm:ss'),
      weight: this.weight,
      width: this.width
    };
  }

  /**
   * Returns a clone of the Parcel.
   *
   */
  clone() {
    var _this$createdAt2, _this$updatedAt2;
    return new Parcel(this.height, this.length, this.weight, this.width, this.id, this.name, this.isDefault, (_this$createdAt2 = this.createdAt) === null || _this$createdAt2 === void 0 ? void 0 : _this$createdAt2.clone(), (_this$updatedAt2 = this.updatedAt) === null || _this$updatedAt2 === void 0 ? void 0 : _this$updatedAt2.clone());
  }

  /**
   * Returns whether the two Parcel are equal.
   *
   */
  equals(parcel) {
    var _this$createdAt3, _parcel$createdAt, _this$updatedAt3, _parcel$updatedAt;
    if (!parcel) {
      return false;
    }
    return ((_this$createdAt3 = this.createdAt) === null || _this$createdAt3 === void 0 ? void 0 : _this$createdAt3.toISOString()) === ((_parcel$createdAt = parcel.createdAt) === null || _parcel$createdAt === void 0 ? void 0 : _parcel$createdAt.toISOString()) && this.height === parcel.height && this.id === parcel.id && this.isDefault === parcel.isDefault && this.length === parcel.length && this.name === parcel.name && ((_this$updatedAt3 = this.updatedAt) === null || _this$updatedAt3 === void 0 ? void 0 : _this$updatedAt3.toISOString()) === ((_parcel$updatedAt = parcel.updatedAt) === null || _parcel$updatedAt === void 0 ? void 0 : _parcel$updatedAt.toISOString()) && this.weight === parcel.weight && this.width === parcel.width;
  }

  /**
   * Returns a JSON with the payload necessary to create a Parcel.
   *
   */
  getCreatePayload() {
    var _this$createdAt4, _this$updatedAt4;
    return {
      created_at: (_this$createdAt4 = this.createdAt) === null || _this$createdAt4 === void 0 ? void 0 : _this$createdAt4.format('YYYY-MM-DD HH:mm:ss'),
      default: this.isDefault,
      height: this.height,
      id: this.id,
      length: this.length,
      name: this.name,
      updated_at: (_this$updatedAt4 = this.updatedAt) === null || _this$updatedAt4 === void 0 ? void 0 : _this$updatedAt4.format('YYYY-MM-DD HH:mm:ss'),
      weight: this.weight,
      width: this.width
    };
  }

  /**
   * Returns a JSON with the payload necessary to update a Parcel.
   *
   */
  getUpdatePayload() {
    var _this$createdAt5, _this$updatedAt5;
    return {
      created_at: (_this$createdAt5 = this.createdAt) === null || _this$createdAt5 === void 0 ? void 0 : _this$createdAt5.format('YYYY-MM-DD HH:mm:ss'),
      default: this.isDefault,
      height: this.height,
      id: this.id,
      length: this.length,
      name: this.name,
      updated_at: (_this$updatedAt5 = this.updatedAt) === null || _this$updatedAt5 === void 0 ? void 0 : _this$updatedAt5.format('YYYY-MM-DD HH:mm:ss'),
      weight: this.weight,
      width: this.width
    };
  }
}) || _class);

export { Parcel };
//# sourceMappingURL=Parcel.js.map
